/**
 * Role Labels Configuration
 * Allows customization of role display names throughout the app
 * 
 * Default labels can be overridden in System Settings by admins
 */

export const DEFAULT_ROLE_LABELS = {
  'system-admin': 'System Admin',
  'owner': 'Owner',
  'admin': 'Admin',
  'employee': 'User',
};

/**
 * Get the display label for a role
 * Falls back to capitalized role name if no custom label is set
 */
export function getRoleLabel(role, customLabels = {}) {
  if (customLabels[role]) {
    return customLabels[role];
  }
  
  if (DEFAULT_ROLE_LABELS[role]) {
    return DEFAULT_ROLE_LABELS[role];
  }
  
  // Fallback: capitalize and replace hyphens with spaces
  return role
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

/**
 * Get role label description for UI hints
 */
export function getRoleDescription(role) {
  const descriptions = {
    'employee': 'View site activity, check-ins, and who is on site',
    'admin': 'Full system access including user and configuration management',
  };

  return descriptions[role] || '';
}
